import { getMetaData } from 'common/header/notifications/hooks/mappers/impl/shared';
import { MappedNotification } from 'src/components/common/header/notifications/Notifications.types';

export function isInvoiceNotification(notification: MappedNotification): boolean {
  return getMetaData(notification).value('SOURCE_TYPE') === 'INVOICING';
}
export function getInvoiceNotificationTitle(notification: MappedNotification): string | undefined {
  return getMetaData(notification).value('REPORT_NAME');
}
